import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import moment from 'moment';
import { interval, Subscription, Subject, throwError } from 'rxjs';
import { IProgram } from '../../../models/IProgram';
import { Observable, of, timer } from 'rxjs';
import { map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { ZoneService } from '../../../services/zone/zone.service';
import { Select, Store } from '@ngxs/store';
import { ProgramActions } from '../programs/store/program.action';
import { ProgramState } from '../programs/store/program.state';
import { Router} from '@angular/router';
import { IUser } from 'src/app/models/IUser';
import { UserState } from 'src/app/store/user.state';
import { IErrorMessage } from 'src/app/widgets/error-message/error-message.interface';
import { API_USER_DEFINED_MESSAGE } from 'src/app/widgets/error-message/error-message.const';
import { FILTER_TYPE, IFilterRequest, IFilterResponse } from 'src/app/shared/filter/filter.interface';
import { ProgramService } from 'src/app/services/aws/program/program.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/widgets/confirm-dialog/confirm-dialog.component';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
    _programs:  IProgram[] = [];
    currDate: any;
    currDateSubscription: Subscription;
    programsSubscription: Subscription;
    format: string;
    dayWrapper: any;
    programs: IProgram[];
    isDesc: boolean = true;
    column: string = 'startDate';
    direction: number = 1;
    isNameAsc: boolean = false;
    isDateAsc: boolean = false;
    programTypeAsc: boolean = false;
    isConfidentialAsc: boolean = false;
    showLoading: boolean = false;
    @Select(UserState.user) user$: Observable<IUser>;
    zones: any;
    role: string;
    filterInput: IFilterRequest;
    isFilterRes: boolean = false;
    public errorMessage: IErrorMessage = {};
    filterRes: string =API_USER_DEFINED_MESSAGE.EMPTY_FILTER_RESPONSE;

    public showFilter: boolean = false;
    selectedItems: Set<string> = new Set();

    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    private destroy$: Subject<void> = new Subject<void>();

    constructor(
        private store: Store,
        private zoneService: ZoneService,
        private router: Router,
        private programservice: ProgramService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef
    ) {
        this.currDate = moment();
        this.currDateSubscription = interval(10000).subscribe(() => {
            this.currDate = moment();
        });
    }

    ngOnInit() {
        this.filterInput = {};
        this.errorMessage = {};
        this.role = (this.router.url === '/admin/programs-external' ? 'facilitator' : 'admin');
        this.programsSubscription = this.store.dispatch(new ProgramActions.GetPrograms()).pipe(
            switchMap(() => this.store.select(ProgramState.getPrograms)),
            map((data: IProgram[] | null) => {
                const safeData = data || [];
                return safeData.filter(x => x.endDate && moment(x.endDate).isSameOrAfter(this.currDate, 'day'));
            }),
            takeUntil(this.destroy$))
            .subscribe((data: IProgram[]) => {
                this.errorMessage.text = data?.length ? '' : API_USER_DEFINED_MESSAGE.EMPTY_RESPONSE;
                this._programs = data;
                const defaultFilterInput = this.getDefaultFilterInput();
                this.programs = this.programservice.filterProgramsBySelectedDate(this.programs, this._programs, defaultFilterInput);
                this.selectedItems.clear();
            },
            () => {
                this._programs = [];
                this.programs = [];
                this.errorMessage.text = API_USER_DEFINED_MESSAGE.FAILED;
            });
    }

    dateformat(param: string): string {
        this.dayWrapper = moment(this.currDate).format('llll');
        var splitted = this.dayWrapper.split(" ");

        if (param.toLowerCase() == "monthwithdate")
            return splitted[1] + ' ' + splitted[2].replace(/,/g, "");
        else if (param.toLowerCase() == 'day') {
            return splitted[0].replace(/,/g, "");
        }
        else if (param.toLowerCase() == "year")
            return splitted[3];
        else if (param.toLowerCase() == "time")
            return splitted[4];
        else if (param.toLowerCase() == "part")
            return splitted[5];
        else if (param.toLowerCase() == "standard")
            return this.getTimeZone();
        else
            return '';
    }

    getTimeZone(): string {
        var offset = new Date().getTimezoneOffset(),
            o = Math.abs(offset);
        var offsetValue = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
        if (offsetValue != undefined && offsetValue != '') {
            this.zones = this.zoneService.getZones();
            if (this.zones) {
                var zone = this.zones.filter(x => x.Offset == offsetValue);
                if (zone.length > 0) return zone[0].Abbreviation;
            }

        }
        return '';
    }

    sort(property) {
        this.isDesc = !this.isDesc;
        this.column = property;
        this.direction = this.isDesc ? 1 : -1;
        switch (property) {
            case 'name':
                this.isNameAsc = !this.isNameAsc;
                break;
            case 'startDate':
                this.isDateAsc = !this.isDateAsc;
                break;
            case 'programType':
                this.programTypeAsc = !this.programTypeAsc;
                break;
            case 'isConfidential':
                this.isConfidentialAsc = !this.isConfidentialAsc;
                break;
        }
    }

    ngOnDestroy() {
        this.currDateSubscription.unsubscribe();
        this.programsSubscription?.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
    }

    public appliedDateFilter(appliedFilter: IFilterResponse): void {
        this.filterInput = appliedFilter;
        this.programs = this.programservice.filterProgramsBySelectedDate(this.programs, this._programs, this.filterInput);
        this.isFilterRes = this.programs.length ? false : true;
        this.selectedItems.clear();
    }

    public resetToDefault(): void {
        this.isFilterRes =false;
        this.filterInput = this.getDefaultFilterInput();
        this.programs = this.programservice.filterProgramsBySelectedDate(this.programs, this._programs, this.filterInput);
        this.selectedItems.clear();
    }

    getDisplayPrograms(): IProgram[] {
        return this.programs || [];
    }

    canToggleIndividualConfidentiality(program: IProgram): boolean {
        return !this.isBulkSelectionActive();
    }

    isBulkSelectionActive(): boolean {
        return this.selectedItems.size > 0;
    }

    clearSelection(): void {
        this.selectedItems.clear();
    }

    isProgramHidden(program: IProgram): boolean {
        return program?.isConfidential === 'true';
    }

    resolveProgramId(program: IProgram): string | null {
        const raw = program?.id;
        if (raw == null) {
            return null;
        }
        const id = String(raw).trim();
        return id || null;
    }

    isSelected(program: IProgram): boolean {
        const id = this.resolveProgramId(program);
        return !!id && this.selectedItems.has(id);
    }

    toggleSelection(program: IProgram) {
        const id = this.resolveProgramId(program);
        if (!id) {
            return;
        }
        if (this.selectedItems.has(id)) {
            this.selectedItems.delete(id);
        } else {
            this.selectedItems.add(id);
        }
    }

    areAllVisibleRowsChecked(): boolean {
        const list = this.getDisplayPrograms();
        return list.length > 0 && list.every((item) => this.isSelected(item));
    }

    toggleSelectAll(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        const list = this.getDisplayPrograms();
        if (isChecked) {
            list.forEach((item) => {
                const id = this.resolveProgramId(item);
                if (id) {
                    this.selectedItems.add(id);
                }
            });
        } else {
            list.forEach((item) => {
                const id = this.resolveProgramId(item);
                if (id) {
                    this.selectedItems.delete(id);
                }
            });
        }
    }

    canBulkHide(): boolean {
        return [...this.selectedItems].some((id) => {
            const program = this.findProgramById(id);
            return !!program && !this.isProgramHidden(program);
        });
    }

    canBulkShow(): boolean {
        return [...this.selectedItems].some((id) => {
            const program = this.findProgramById(id);
            return !!program && this.isProgramHidden(program);
        });
    }

    getBulkSelectionSummary(): string {
        const selected = [...this.selectedItems]
            .map((id) => this.findProgramById(id))
            .filter((program): program is IProgram => !!program);
        if (!selected.length) {
            return '';
        }
        const hiddenCount = selected.filter((program) => this.isProgramHidden(program)).length;
        const visibleCount = selected.length - hiddenCount;
        return `${visibleCount} visible, ${hiddenCount} confidential`;
    }

    toggleProgramConfidentiality(program: IProgram) {
        if (!this.canToggleIndividualConfidentiality(program)) {
            return;
        }
        const programId = this.resolveProgramId(program);
        if (!programId) {
            return;
        }
        if (!this.isProgramHidden(program)) {
            this.openConfirmDialog('Are you sure you want to mark this program as confidential?')
                .pipe(take(1))
                .subscribe((result) => {
                    if (result) {
                        this.updateConfidentiality([programId], true);
                    }
                });
        } else {
            this.openConfirmDialog('Are you sure you want to remove confidential status from this program?')
                .pipe(take(1))
                .subscribe((result) => {
                    if (result) {
                        this.updateConfidentiality([programId], false);
                    }
                });
        }
    }

    bulkHide() {
        const ids = this.getSelectedIdsForConfidentiality(false);
        if (!ids.length) {
            return;
        }
        this.openConfirmDialog('Are you sure you want to mark the selected program(s) as confidential?')
            .pipe(take(1))
            .subscribe((result) => {
                if (result) {
                    this.updateConfidentiality(ids, true);
                }
            });
    }

    bulkShow() {
        const ids = this.getSelectedIdsForConfidentiality(true);
        if (!ids.length) {
            return;
        }
        this.openConfirmDialog('Are you sure you want to remove confidential status from the selected program(s)?')
            .pipe(take(1))
            .subscribe((result) => {
                if (result) {
                    this.updateConfidentiality(ids, false);
                }
            });
    }

    private findProgramById(id: string): IProgram | undefined {
        return this.getDisplayPrograms().find((program) => this.resolveProgramId(program) === id);
    }

    private getSelectedIdsForConfidentiality(hiddenOnly: boolean): string[] {
        return [...this.selectedItems].filter((id) => {
            const program = this.findProgramById(id);
            if (!program) {
                return false;
            }
            return hiddenOnly ? this.isProgramHidden(program) : !this.isProgramHidden(program);
        });
    }

    private updateConfidentiality(programIds: string[], isConfidential: boolean) {
        const successMessage = isConfidential
            ? 'Program(s) marked as confidential.'
            : 'Program(s) are now visible.';
        this.showLoading = true;
        this.programservice.updateProgramConfidentiality(programIds, isConfidential)
            .pipe(
                switchMap(() => this.pollListUntilConfidentialityReflected(programIds, isConfidential)),
                takeUntil(this.destroy$)
            )
            .subscribe({
                next: () => {
                    this.selectedItems.clear();
                    this.showLoading = false;
                    this.cdr.detectChanges();
                    this.snackBar.open(successMessage, 'OK', {
                        duration: 5000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                        panelClass: ['success-snackbar']
                    });
                },
                error: () => {
                    this.showLoading = false;
                    this.cdr.detectChanges();
                    this.snackBar.open('Something went wrong, please try again later.', 'OK', {
                        duration: 8000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                        panelClass: ['error-snackbar']
                    });
                }
            });
    }

    private getDefaultFilterInput(): IFilterRequest {
        const myCurrentDate = new Date();
        const myFutureDate = new Date();
        myCurrentDate.toUTCString();
        myFutureDate.toUTCString();
        myCurrentDate.setDate(myCurrentDate.getDate());
        myFutureDate.setDate(myFutureDate.getDate() + 180);
        myFutureDate.setHours(0, 0, 0, 0);
        myCurrentDate.setHours(0, 0, 0, 0);
        return {
            filterType: FILTER_TYPE.FROM,
            startDate: myCurrentDate,
            endDate: myFutureDate
        };
    }

    private pollListUntilConfidentialityReflected(
        programIds: string[],
        isConfidential: boolean,
        attempt = 1,
        maxAttempts = 15,
        pollIntervalMs = 1000
    ): Observable<IProgram[]> {
        return this.programservice.getProgramsList().pipe(
            tap((data: IProgram[]) => {
                // Update store with fresh data from API
                this.store.dispatch(new ProgramActions.SetPrograms(data));
            }),
            switchMap((data: IProgram[]) => {
                // Filter programs with valid end dates
                this._programs = data.filter(x =>
                    x.endDate && moment(x.endDate).isSameOrAfter(this.currDate, 'day')
                );

                // Apply date filter
                const filterToUse = this.filterInput?.filterType
                    ? this.filterInput
                    : this.getDefaultFilterInput();
                this.programs = this.programservice.filterProgramsBySelectedDate(
                    [],
                    this._programs,
                    filterToUse
                );

                // Check if update is reflected or max attempts reached
                if (this.listReflectsConfidentialityUpdate(this._programs, programIds, isConfidential)) {
                    return of(this.programs);
                }

                if (attempt >= maxAttempts) {
                    return throwError(() => new Error('Timed out waiting for confidentiality update to be reflected.'));
                }

                // Continue polling
                return timer(pollIntervalMs).pipe(
                    switchMap(() => this.pollListUntilConfidentialityReflected(
                        programIds,
                        isConfidential,
                        attempt + 1,
                        maxAttempts,
                        pollIntervalMs
                    ))
                );
            })
        );
    }

    private listReflectsConfidentialityUpdate(
        programs: IProgram[],
        programIds: string[],
        isConfidential: boolean
    ): boolean {
        const expectedValue = isConfidential ? 'true' : 'false';
        return programIds.every((id) => {
            const program = programs.find((item) => this.resolveProgramId(item) === id);
            return program?.isConfidential === expectedValue;
        });
    }

    private openConfirmDialog(body: string): Observable<boolean> {
        return this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: '',
                body,
                buttonTextNo: 'Cancel',
                buttonTextYes: 'Yes, continue'
            },
            panelClass: 'notification-submit-dialog',
            disableClose: true
        }).afterClosed();
    }
}


